import { createI18n } from 'vue-i18n'
import appStore from '@/stores/app.store'
import messages from '@intlify/unplugin-vue-i18n/messages'

const i18n = createI18n({
  legacy: false,
  locale: appStore.state.languageCode,
  fallbackLocale: 'de',
  globalInjection: true,
  fallbackWarn: false,
  missingWarn: false,
  messages,
})

export default i18n
